import VendorCreditCreate from "./VendorCreditCreate/VendorCreditCreate"
import VendorCreditDetails from "./VendorCreditDetails/VendorCreditDetails"
import VendorCreditEdit from "./VendorCreditEdit/VendorCreditEdit"
import VendorCreditList from "./VendorCreditList/VendorCreditList"
import VendorCreditsFeatureGate from "./components/VendorCreditsFeatureGate/VendorCreditsFeatureGate"

function Create() {
    return (
        <VendorCreditsFeatureGate>
            <VendorCreditCreate />
        </VendorCreditsFeatureGate>
    )
}

function Details() {
    return (
        <VendorCreditsFeatureGate>
            <VendorCreditDetails />
        </VendorCreditsFeatureGate>
    )
}

function Edit() {
    return (
        <VendorCreditsFeatureGate>
            <VendorCreditEdit />
        </VendorCreditsFeatureGate>
    )
}

function List() {
    return (
        <VendorCreditsFeatureGate>
            <VendorCreditList />
        </VendorCreditsFeatureGate>
    )
}

export default {
    Create,
    Details,
    Edit,
    List,
}
